import React, { useEffect, useRef, useState } from "react";

const RestaurantDropdown = ({
  shops = [],
  restaurants = [],
  value = "",
  onChange,
  loading = false,
  placeholder = "All Restaurants",
  className = "",
}) => {
  const data = shops.length ? shops : restaurants;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [search, setSearch] = useState("");

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

const filteredShops = data.filter((shop) =>
  String(shop?.shop_name || shop?.restaurantName || shop?.name || "")
    .toLowerCase()
    .includes(search.toLowerCase()),
);

const selectedRestaurant = data.find(
  (shop) =>
    String(shop?.shop_code || shop?.restaurantId || shop?.code) ===
    String(value),
);

  return (
    <div
      ref={dropdownRef}
      className={`relative w-full ${className}`}
      style={{
        zIndex: dropdownOpen ? 9999999 : 1,
      }}
    >
      <button
        type="button"
        disabled={loading}
        onClick={() => setDropdownOpen((prev) => !prev)}
        className={`w-full px-3 py-2 border rounded bg-white flex items-center justify-between gap-2 text-sm focus:outline-none focus:ring-1 focus:ring-orange-500 ${
          loading ? "bg-gray-100 cursor-not-allowed" : ""
        }`}
      >
        <span className="min-w-0 flex-1 truncate text-left">
          {selectedRestaurant
            ? selectedRestaurant.shop_name || selectedRestaurant.name
            : placeholder}
        </span>

        <svg
          className={`w-4 h-4 shrink-0 transition-transform ${
            dropdownOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {dropdownOpen && (
        <div
          className="absolute left-0 w-full max-h-[320px] overflow-hidden rounded-lg border bg-white shadow-xl"
          style={{
            top: "calc(100% + 6px)",
            bottom: "auto",
            left: 0,
            right: "auto",
            zIndex: 9999999,
          }}
        >
          <div className="sticky top-0 z-10 border-b bg-white p-2">
            <input
              type="text"
              placeholder="Search restaurant..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full rounded border px-3 py-2 text-sm outline-none focus:border-orange-500"
              autoFocus
            />
          </div>

          <div className="max-h-60 overflow-y-auto">
            <button
              type="button"
              onClick={() => {
                onChange("");
                setSearch("");
                setDropdownOpen(false);
              }}
              className="block w-full border-b px-3 py-2 text-left text-sm hover:bg-orange-100"
            >
              {placeholder}
            </button>

            {filteredShops.map((shop) => {
              const shopCode =
                shop?.shop_code || shop?.restaurantId || shop?.code;

              const shopName =
                shop?.shop_name || shop?.restaurantName || shop?.name;

              return (
                <button
                  type="button"
                  key={shopCode}
                  onClick={() => {
                    onChange(shopCode);
                    setSearch("");
                    setDropdownOpen(false);
                  }}
                  className="block w-full border-b px-3 py-2 text-left text-sm hover:bg-orange-100 last:border-b-0"
                >
                  {shopName}
                </button>
              );
            })}

            {!filteredShops.length && (
              <div className="px-3 py-3 text-sm text-gray-500">
                No restaurants found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RestaurantDropdown;